import { render } from "./ProfileViewLink.vue?vue&type=template&id=28f0546f&ts=true"
import script from "./ProfileViewLink.vue?vue&type=script&lang=ts"
export * from "./ProfileViewLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__